{
  "name": "@jspsych-contrib/plugin-pipe",
  "version": "0.5.0",
  "description": "jsPsych plugin to faciliate communication with [DataPipe](https://pipe.jspsych.org)",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jspsych/jspsych-contrib.git",
    "directory": "packages/plugin-pipe"
  },
  "author": {
    "name": "Josh de Leeuw",
    "url": "https://github.com/jodeleeuw"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jspsych-contrib/issues"
  },
  "homepage": "https://github.com/jspsych/jspsych-contrib/tree/main/packages/plugin-pipe",
  "peerDependencies": {
    "jspsych": ">=8.0.0"
  },
  "devDependencies": {
    "@jspsych/config": "^3.2.1",
    "@jspsych/test-utils": "^1.0.0",
    "jspsych": "^8.0.0"
  }
}
